import { defineMessages } from "react-intl";

const baseId = "t.components.TaskOperationField.";

export default defineMessages({
  "@fixed_name": {
    id: baseId + "fixed_name",
    defaultMessage: "Name",
  },
  "@fixed_last_access_date": {
    id: baseId + "fixed_last_access_date",
    defaultMessage: "Last access date",
  },
  "@fixed_display_name": {
    id: baseId + "fixed_display_name",
    defaultMessage: "Display name",
  },
  "@fixed_code": {
    id: baseId + "fixed_code",
    defaultMessage: "Code",
  },
  "@fixed_last_wrong_login": {
    id: baseId + "fixed_last_wrong_login",
    defaultMessage: "Last wrong login",
  },
  "@fixed_dn": {
    id: baseId + "fixed_dn",
    defaultMessage: "DN",
  },
  "@fixed_email": {
    id: baseId + "fixed_email",
    defaultMessage: "Email",
  },
  "@fixed_isDefault": {
    id: baseId + "fixed_isDefault",
    defaultMessage: "Default",
  },
  "@fixed_accountType_name": {
    id: baseId + "fixed_accountType_name",
    defaultMessage: "Account type name",
  },
  "@fixed_expire": {
    id: baseId + "fixed_expire",
    defaultMessage: "Expire date",
  },
  "@fixed_surname": {
    id: baseId + "fixed_surname",
    defaultMessage: "Surname",
  },
  "@fixed_last_pwd_change": {
    id: baseId + "fixed_last_pwd_change",
    defaultMessage: "Last password change",
  },
  "@fixed_number_login_error": {
    id: baseId + "fixed_number_login_error",
    defaultMessage: "Login error number",
  },
});
